import { render, staticRenderFns } from "./ProjectContractRetail.vue?vue&type=template&id=9b947552&scoped=true&"
import script from "./ProjectContractRetail.vue?vue&type=script&lang=js&"
export * from "./ProjectContractRetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b947552",
  null
  
)

export default component.exports